"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteAttributeDialog = exports.AddValueDialog = exports.AddAttributeDialog = void 0;
var add_attribute_dialog_container_1 = require("./add-attribute-dialog.container");
Object.defineProperty(exports, "AddAttributeDialog", { enumerable: true, get: function () { return add_attribute_dialog_container_1.AddAttributeContainer; } });
var add_value_dialog_container_1 = require("./add-value-dialog.container");
Object.defineProperty(exports, "AddValueDialog", { enumerable: true, get: function () { return add_value_dialog_container_1.AddValueContainer; } });
var delete_attribute_dialog_1 = require("./delete-attribute-dialog");
Object.defineProperty(exports, "DeleteAttributeDialog", { enumerable: true, get: function () { return delete_attribute_dialog_1.DeleteAttributeDialog; } });
